export const cookies_string = 'HKULEARNING';
export const server_ip=''//'http://localhost:5001';

//prod: 'http://43.198.18.229
